<template lang="pug">
    el-button.ButtonNext(@click="nextStepSCORM" type="primary") Ok, ¡Entendido!
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'ButtonNext2',  
  methods: {    
    ...mapActions(['nextStepSCORM', 'nextStepSCORM2'])
  }
}
</script>

<style scoped>
@import 'button-next.scss';
</style>

